module.exports = __webpack_public_path__ + "static/media/star_empty.dd0c00b1.svg";